import { render, staticRenderFns } from "./AttendanceAbnormalPanel.vue?vue&type=template&id=20e4dbda&scoped=true&"
import script from "./AttendanceAbnormalPanel.vue?vue&type=script&lang=js&"
export * from "./AttendanceAbnormalPanel.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceAbnormalPanel.vue?vue&type=style&index=0&id=20e4dbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4dbda",
  null
  
)

export default component.exports